import {
  mapTagTaskToTasklist,
  mapTagWorkstreamToTagWorkstream,
  mapTagWorkstreamToWorkstreams,
  mapTaskListToTasks,
} from '../Helper';
import { UserWithFullNameAndEmail } from '../types';

export const mapLegacyInboxEntryCommonProps = (rawInboxEntry) => {
  const workstreams = mapTagWorkstreamToWorkstreams(rawInboxEntry.workstreamTag);
  const tagWorkstream = mapTagWorkstreamToTagWorkstream(rawInboxEntry.workstreamTag);
  const taskList = mapTagTaskToTasklist(rawInboxEntry.taskTag);
  const tasks = mapTaskListToTasks(taskList);
  const accessList = rawInboxEntry.accessList.map((al) => ({
    id: al.id,
    firstName: al.firstName,
    lastName: al.lastName,
    avatar: al.avatar,
  }));

  return {
    id: rawInboxEntry.id,
    source: rawInboxEntry.source,
    subject: rawInboxEntry.subject,
    from: rawInboxEntry.from,
    status: rawInboxEntry.status,
    createdDate: rawInboxEntry.receivedOn,
    openedDate: rawInboxEntry.opened,
    openedBy: rawInboxEntry.openBy,
    closedDate: rawInboxEntry.closed,
    closedBy: rawInboxEntry.closedBy,
    modifiedDate: rawInboxEntry.modified,
    modifiedBy: rawInboxEntry.modifiedBy,
    isMisc: rawInboxEntry.isMisc,
    workstreams: workstreams,
    tasks: tasks,
    taskList: taskList,
    accessList: accessList,
    tagWorkstream: tagWorkstream,
  };
};

export const getUserWithEmailDisplay = (from: UserWithFullNameAndEmail) => {
  if (from.fullName && from.emailAddress) {
    return `${from.fullName} <${from.emailAddress}>`;
  }

  if (from.fullName && !from.emailAddress) {
    return `${from.fullName}`;
  }

  return `${from.emailAddress}`;
};

export const geInboxEntryPermissions = (rawPermissions: string[]) => {
  const permissions = {};

  for (const permission of rawPermissions) {
    permissions[permission] = true;
  }

  return permissions;
};

export const geInboxEntryAllowClose = (rawAllowClose) => {
  if (!rawAllowClose) {
    return {
      allowed: false,
    };
  }

  return {
    allowed: rawAllowClose.allowed,
    reasonCode: rawAllowClose['reason-code'],
  };
};

export const mapInboxEntryWorkstreams = (rawWorkstreams) => {
  return rawWorkstreams.map((ws) => ({
    ...ws,
    isPermanent: ws['is-permanent'],
  }));
};
